import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingsService } from '@appRoot/core/services/settings.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAvailableDataIndexParams, AvailableData } from '../models';


@Injectable({
    providedIn: 'root'
})
export class AvailableDataHttpService {

    public readonly edge: string = 'available-data';

    constructor(
        private http: HttpClient,
        private settings: SettingsService,
    ) { }

    fetch(params: IAvailableDataIndexParams): Observable<AvailableData> {
        let _params = new HttpParams({ fromObject: <any>{ ...params } });

        return this.http.get<{ data: AvailableData }>(`${this.settings.API_PATH}/${this.edge}`, { params: _params }).pipe(
            map(({ data }) => data),
        );
    }
}
